import React, { useContext, useEffect, useState, useRef } from 'react';
import _ from "lodash";
import CustomerProductContext from '../../ContextFiles/CustomerProductContext';
import { Row, Col, Button, Card, Dropdown, Menu, Carousel, Modal, message, Tooltip, Typography, Input, Image } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, DownOutlined, LoadingOutlined, HeartFilled, HeartOutlined, PictureOutlined, FlagOutlined, DeleteOutlined, EditOutlined, FullscreenOutlined, PlayCircleFilled } from '@ant-design/icons';
import FileConstants from '../../../../FileConstants';
import ImageMagnify from '../ImageMagnify/ImageMagnify';
import * as Utilities from '../../Utilities.jsx';
import ENVIRONMENT from '../../../../environments';
import axios from 'axios';
import DeleteImageModal from './DeleteImageModal';
import './ProductComponents.scss';
import ZoomImage from './imageZoomable.jsx';
import AiProductBadge from '../AiProduct/AiProductBadge.jsx';
import QRCode from 'react-qr-code';
import ProductPageConstants from './ProductPageConstants.js';
import SiloPhotographyPresetsModal from '../../SiloPhotography/SiloPhotographyPresetsModal.jsx';
import { addDownloadIconObserver,getImgDisplayName, showCustomToast } from '../../../../utils/addImageDownload';
import AIImageCarousel from '../TwoDImagesPage/AIImageCarousel.jsx';
import ReactPlayer from 'react-player';

const { Text } = Typography;
const { SubMenu } = Menu;

const COMPANY_ID = localStorage.getItem('company_id');
const CUSTOMER_USERNAME = localStorage.getItem("username");

const customSortOrder = {
    "silo": 0,
    "dim": 1,
    "low_res_preview": 2,
    "lifestyle": 3
};


const ImageListType = (props) => {
    const filteredImages = props.allProductImages.filter(image => {
        if (props.type.includes(image.main_type)) {
            // Special handling for ai_lifestyle based on is_final_image
            if (props.isAiModel && (image.main_type === 'ai_lifestyle')) {
                if (props.name === 'Final Images') {
                    return image?.is_final_image === true;
                } else if (props.name === 'Generations' || props.name === 'Previews') {
                    return !image?.is_final_image;
                }
            }
            return true;
        }
        return false;
    });

    return (filteredImages.length > 0 ?
        <>
            <div className='manrope f-14 grey-8c w-100'>{props.name}</div>
            {filteredImages.map((image, index) => (
                <Card className={`product-img-grid-card display-flex ${props.selectedProductImage == image.url && !props.viewing3D ? `selected` : ``}`}
                    key={index} onClick={() => {
                            props.selectImage(image.url); 
                            if(props.type.includes('lifestyle')){
                                props.setSelectedLifestyleSceneId(image.scene_id)
                                props.setSelectedFilenameWithExtension(image.filename)
                            }
                            if(props.type.includes('silo')){
                                props.setSelectedFilenameWithExtension(image.filename)
                            }
                            if(props.type.includes('ai_lifestyle')){
                                props.setSelectedAiImageId(image.id);
                            }
                            if(props.type.includes('ai_video')){
                                props.setSelectedAiImageId(image.id);
                            }
                        }}>
                    {props.type.includes('ai_video') ? (
                        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                            <img 
                                className='product-img-grid-img' 
                                src={image.thumbnail || image.low_url} 
                                style={{ 
                                    filter: image.status === 'inprogress' ? 'blur(4px)' : 'none',
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain'
                                }}
                            />
                            <PlayCircleFilled
                                style={{
                                    fontSize: "32px",
                                    opacity: "70%",
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    color: "#fff"
                                }}
                            />
                        </div>
                    ) : (
                        <img className='product-img-grid-img' src={image.low_url} />
                    )}
                </Card>
            ))}
        </> : "")
}


const ProductImageCarousel = ({tab_name}) => {
    // let carousel = React.createRef();
    const carousel = useRef(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [deleteImageType, setDeleteImageType] = useState('')
    const [selectedDeleteLifestyle, setSelectedDeleteLifestyle] = useState('')
    const [selectedDeleteSilo, setSelectedDeleteSilo] = useState('')
    const [selectedDeleteSiloURL, setSelectedDeleteSiloURL] = useState('')
    const [selectedLifestyleSceneId, setSelectedLifestyleSceneId] = useState(0)
    const [collaborateConfirmButtonLoader, setCollaborateConfirmButtonLoader] = useState(false)
    const [collaborationConfirmModal, setCollaborationConfirmModal] = useState(false)
    const [isEditing, setIsEditing] = useState(false);
    const [openSiloPresetModal, setOpenSiloPresetModal] = useState(false);
    const [selectedPreset, setSelectedPreset] = useState(-1);
    const [allPresets, setAllPresets] = useState([]);
    const [selectedAiImageId, setSelectedAiImageId] = useState('');
    const [filenameBeingEdited, setFilenameBeingEdited] = useState(false)
    const [editRenderNameLoader, setEditRenderNameLoader] = useState(false)
    const [editedRenderUrl, setEditedRenderUrl] = useState(null)
    const [previousRenderName, setPreviousRenderName] = useState(null)
    const [tooltipVisible, setTooltipVisible] = useState(false)
    const [aiIframe2LoadOnce, setAiIframe2LoadOnce] = useState(false);
    const [finalImageGenerationLoader, setFinalImageGenerationLoader] = useState(false)

    const { hasGlb, allProductImages, productImageCount, downloadImagesArchive, setSelectedImgOriginalFormat, setIfIframe2LoadedOnce, ifIframe2LoadedOnce,
        imgAccessedFromCarousel, setImgAccessedFromCarousel, selectedImgOriginalFormat, selectedImgFilename, getMetadata,
        setSelectedImgFilename, selectedProductImage, setSelectedProductImage, downloadSiloImages, isStorePage, product_id,
        companyId, setAllProductImages, setProductImageCount, secondaryShots, setSecondaryShots, productAssetData, getDownloadUrl, productData,
        setProductAssetData, allSystemGeneratedProductImages, selectedImageResolution, setSelectedImageResolution, isAiModel, expandImage, changeVisibility, image_visible,
        setSelectedImageFormat, selectedImageFormat, setSelectedImageName, selectedImageName, selectedImageCreationDate, selectedImage, setSelectedImage,
        setSelectedImageCreationDate, baseVariantPlatform, selectedImageType, setSelectedImageType, selectedImageCapturedBy, setSelectedImageCapturedBy, modelStatus,
        openVideoModal, statusOfMp4Video, openDimensionalModal, openThreeSixtyModal, statusOf360Spin, openVariationModal, setSelectedFilenameWithExtension,
        selectedFilenameWithExtension, selectedAsset, viewing3D, setViewing3D, viewingAiModel, setViewingAiModel, openAllTab } = useContext(CustomerProductContext);

    const prevSelectedAssetRef = useRef(selectedAsset);

    allProductImages.sort((a, b) => customSortOrder[a.main_type] - customSortOrder[b.main_type]);

    const updateProductImages = (images) => {
        setAllProductImages(images)
    }

    const handleFavorite = (obj = null) => {
        let filtered_images = getFilteredImagesForTab();
        let images = filtered_images.filter(img => img.url === selectedProductImage);
        let image = null;
        if(images.length == 1){
            image = images[0]
        }
        console.log("*****Here", image
        )        
        if(image['type'] == 'lifestyle'){
        // pass lifestyleRenders list and setLifestyleRenders function so that the function can update the state
        Utilities.updateLifestyleFavoriteStatus(image.scene_id, image.filename, filtered_images, updateProductImages, CUSTOMER_USERNAME)
        }
        else if(image['type'] == 'silo'){
        image['product_id'] = product_id
        // pass silos list and setSilos function so that the function can update the state
        Utilities.updateSiloFavoriteStatus(image.product_id, image.camera_name + '.' + image.format, filtered_images, updateProductImages, CUSTOMER_USERNAME)
        }
        else if(image['type'] == 'ai_lifestyle'){
            // pass aiImages list and setAiImages function so that the function can update the state
            Utilities.updateAiFavoriteStatus(image.id, image?.id.toString() + ".jpg", filtered_images, updateProductImages, CUSTOMER_USERNAME)
            // Update selectedImage to reflect the favorite status change
            if(selectedImage && selectedImage.id === image.id){
                setSelectedImage({ ...selectedImage, isFavourite: !selectedImage.isFavourite });
            }
        }

    }

    const setInitialImageDetails = (image) => {
        setSelectedImage(image);
        setSelectedProductImage(image.url);
        setSelectedImgOriginalFormat(image.format);
        setSelectedImgFilename(image.filename);
        setSelectedImageResolution(image.resolution);
        setSelectedImageFormat(image.format);
        setSelectedImageName(image.display_name);
        setSelectedImageCapturedBy(image.captured_by)
        setSelectedImageCreationDate(image.created_at);
        setSelectedImageType(image.main_type)
        setSelectedFilenameWithExtension(image.filename)
    };

    const downloadImage = () => {
        downloadSingleImage(selectedImage);
    };  

    const downloadSingleImage = (img) => {
        showCustomToast();
        Utilities.downloadImage(selectedImageFormat == "tiff" ? selectedProductImage.replace("jpg", "tiff") : selectedProductImage, selectedImageName + '.' + selectedImageFormat);
    }

    useEffect(() => {
        const observer = addDownloadIconObserver(downloadImage);
        return () => observer.disconnect();
    }, [selectedProductImage, selectedImage]); 

    useEffect(() => {
        let filtered_images = getFilteredImagesForTab();
        if (imgAccessedFromCarousel == false && viewing3D == false && carousel) {
            let image_index = filtered_images.findIndex(img => img.url == selectedProductImage);
            changeCarouselSlide(image_index);
        }
    }, [selectedProductImage, imgAccessedFromCarousel, viewing3D]);

    // Reset edit state when image changes (e.g., when switching tabs)
    useEffect(() => {
        resetRenderNameField();
    }, [tab_name]);

    // Sync selectedImage with allProductImages when favorite status changes
    useEffect(() => {
        if (selectedImage && selectedImage.id && selectedImageType === 'ai_lifestyle' && selectedImage.url === selectedProductImage) {
            const updatedImage = allProductImages.find(img => img.id === selectedImage.id && img.url === selectedProductImage);
            if (updatedImage && (
                updatedImage.isFavourite !== selectedImage.isFavourite ||
                (updatedImage.favouriteId !== selectedImage.favouriteId && updatedImage.favouriteId !== undefined)
            )) {
                setSelectedImage(updatedImage);
            }
        }
    }, [allProductImages, selectedImage?.id, selectedImage?.isFavourite, selectedImage?.favouriteId, selectedImageType, selectedProductImage]);

    const selectImage = (url) => {
        let filtered_images = getFilteredImagesForTab();
        resetRenderNameField()
        setViewing3D(false);
        setSelectedProductImage(url);
        let image_index = filtered_images.findIndex(img => img.url == url);
        setSelectedImage(filtered_images[image_index]);
        setSelectedImgOriginalFormat(filtered_images[image_index].format);
        setSelectedImgFilename(filtered_images[image_index].display_name ? allProductImages[image_index].display_name : allProductImages[image_index].filename);
        setSelectedImageResolution(filtered_images[image_index].resolution);
        setSelectedImageFormat(filtered_images[image_index].format);
        setSelectedImageName(filtered_images[image_index].display_name);
        setSelectedImageCapturedBy(filtered_images[image_index].captured_by);
        setSelectedImageType(filtered_images[image_index].main_type);
        setSelectedImageCreationDate(filtered_images[image_index].created_at);
            
        changeCarouselSlide(image_index);
        setImgAccessedFromCarousel(true);
    }

    const onChangeCarousel = (before, to) => {
        setViewing3D(false);
        if (before == (productImageCount - 1) && to == 0) {
            changeCarouselSlide(0);
            setImgAccessedFromCarousel(true);
        } else if (before == 0 && to == (productImageCount - 1)) {
            changeCarouselSlide(productImageCount - 1);
            setImgAccessedFromCarousel(true);
        }
    }

    const changeCarouselSlide = (index) => {
        if (carousel.hasOwnProperty("current") && carousel?.current) {
            carousel.current.goTo(index, true);
        } else if (carousel && typeof carousel.goTo === 'function') {
            carousel.goTo(index, true);
        }
    }

    const next = () => {
        let images = getFilteredImagesForTab();
        let image_count = images.length;
        let image_index = images.findIndex(img => img.url == selectedProductImage);
        setViewing3D(false);
        if ((image_index + 1) == image_count) {
            setSelectedImage(images[0]);
            setSelectedProductImage(images[0].url)
            setSelectedImageResolution(images[0].resolution);
            setSelectedImageFormat(images[0].format);
            setSelectedImageName(images[0].display_name);
            setSelectedImageCapturedBy(images[0].captured_by);
            setSelectedImageType(images[0].main_type);
            setSelectedImageCreationDate(images[0].created_at);

            changeCarouselSlide(0);
            setImgAccessedFromCarousel(true);
        } else {
            setSelectedImage(images[image_index + 1]);
            setSelectedProductImage(images[image_index + 1].url);
            setSelectedImageResolution(images[image_index + 1].resolution);
            setSelectedImageFormat(images[image_index + 1].format);
            setSelectedImageName(images[image_index + 1].display_name);
            setSelectedImageCapturedBy(images[image_index + 1].captured_by);
            setSelectedImageType(images[image_index + 1].main_type);
            setSelectedImageCreationDate(images[image_index + 1].created_at);

            changeCarouselSlide(image_index + 1);
            setImgAccessedFromCarousel(true);
        }
        resetRenderNameField()
    }

    const prev = () => {
        let images = getFilteredImagesForTab();
        let image_count = images.length;
        let image_index = images.findIndex(img => img.url === selectedProductImage);
        setViewing3D(false);
        //if user moves back from step from carousel then close the carousel
        if ((image_index - 1) < 0) {
            changeCarouselSlide(images - 1);
            setSelectedImage(images[image_count - 1]);
            setSelectedProductImage(images[image_count - 1].url);
            setImgAccessedFromCarousel(true);
            setSelectedImageResolution(images[image_count - 1].resolution);
            setSelectedImageFormat(images[image_count - 1].format);
            setSelectedImageName(images[image_count - 1].display_name);
            setSelectedImageCapturedBy(images[image_count -1].captured_by);
            setSelectedImageType(images[image_count - 1].main_type);
            setSelectedImageCreationDate(images[image_count - 1].created_at);

        } else {
            setSelectedImage(images[image_index - 1]);
            setSelectedProductImage(images[image_index - 1].url);
            setSelectedImageResolution(images[image_index - 1].resolution);
            setSelectedImageFormat(images[image_index - 1].format);
            setSelectedImageName(images[image_index - 1].display_name);
            setSelectedImageCapturedBy(images[image_index - 1].captured_by);
            setSelectedImageType(images[image_index - 1].main_type);
            setSelectedImageCreationDate(images[image_index - 1].created_at);
            changeCarouselSlide(image_index - 1);
            setImgAccessedFromCarousel(true);
        }
        resetRenderNameField()
    }

    const getNextImageURL = (allProductImages) => {
        let filtered_images = getFilteredImagesForTab();
        let image_count = filtered_images.length;
        let image_index = filtered_images.findIndex(img => img.url == selectedProductImage);
        if ((image_index + 1) == image_count) {
            return filtered_images[image_count - 1].url;
        } else {
            return filtered_images[image_index + 1].url;
        }
    }

    const getNextImageURLForAI = (allProductImages) => {
        let image_index = allProductImages.findIndex(img => img.url == selectedProductImage);
        if ((image_index + 1) == productImageCount) {
            return allProductImages[image_index - 1].url;
        } else {
            return allProductImages[image_index + 1].url;
        }
    }

    const getImageNumber = () => {
        let filtered_images = getFilteredImagesForTab();
        let image_index = filtered_images.findIndex(img => img.url === selectedProductImage);
        return image_index + 1;
    }

    const getStatus = () => {
        let filtered_images = getFilteredImagesForTab();
        let image = filtered_images.filter(img => img.url === selectedProductImage);
        let status = "";
        if (image.length > 0) {
            status = image[0].status;
        }

        return status;
    }

    const createCollaborateEntity = () => {
        
        let payload = {
            'camera_name': selectedFilenameWithExtension,
            'display_name': selectedImageName,
            'created_by': localStorage.getItem('username'),
            'last_modified_by': localStorage.getItem('username'),
            'state': {}
        }
        payload['is_msprovider'] = FileConstants.isMSProvider;
        if(selectedImageType == 'silo'){
            let base_url = ENVIRONMENT.getBaseURL(baseVariantPlatform)
            let renderPath = selectedProductImage.split(base_url)[1]
            payload['render_path'] = renderPath
            payload['product_id'] = product_id
        }
        else{
            payload['scene_id'] = selectedLifestyleSceneId
        }

        axios.post(ENVIRONMENT.CREATE_COLLABORATE_ENTITY, payload)
        .then(res => {
            if (res.data && res.data.body) {
                setCollaborationConfirmModal(false)
                setCollaborateConfirmButtonLoader(false)
                let collaboration_id = res.data.body.collaboration_entity_id;
                let url = '/collaborate-tool/'+ collaboration_id;
                let new_window = window.open(url, '_blank');
                if (new_window) {
                    new_window.focus();
                } else {
                    window.location.href = url;
                }
            }
        })
    }

    const openCollaborateTool = () => {
        setCollaborateConfirmButtonLoader(true)

        let payload = {
            'camera_name': selectedFilenameWithExtension
        }
        if(selectedImageType == 'lifestyle'){
            payload.scene_id = selectedLifestyleSceneId
        }
        else if(selectedImageType == 'silo'){
            payload.product_id = product_id
        }

        axios.post(ENVIRONMENT.GET_COLLABORATE_ENTITY, payload)
            .then(res => {
                console.log('res', res)
                if (res.data && res.data.length == 0) {
                    createCollaborateEntity();
                } else {
                    setCollaborationConfirmModal(false);
                    setCollaborateConfirmButtonLoader(false)
                    let collaboration_id = res.data.collaboration_entity_id;
                    let url = '/collaborate-tool/' + collaboration_id;

                    let new_window = window.open(url, '_blank');
                    if (new_window) {
                        new_window.focus();
                    } else {
                        window.location.href = url;
                    }
                }
            });
    }

    const deleteLifestyle = () => {
        setDeleteLoader(true)
        let payload = {
            action: "hide_camera_product_mapping",
            product_ids: [product_id],
            old_camera: selectedDeleteLifestyle.split('.')[0],
            scene_id: selectedLifestyleSceneId
        }
        axios.post(ENVIRONMENT.CAMERA_PRODUCT_MAP_CONTROLLER, payload)
        const allImages = [];
        for (const imageObj of productAssetData['lifestyle_data']) {
            if (!(imageObj.filename == selectedDeleteLifestyle && imageObj.scene_id == selectedLifestyleSceneId)) {
                allImages.unshift(imageObj);
            }
        }

        productAssetData['lifestyle_data'] = allImages
        productAssetData['silo_data'] = productAssetData['silo_data']?.length > 0 && productAssetData['silo_data'].reverse()

        setDeleteLoader(false);
        setDeleteModal(false);
        message.info('Lifestyle Image Deleted.');
        allSystemGeneratedProductImages(productAssetData);

        const allProdImages = [];
        let filtered_images = getFilteredImagesForTab();
        for (const imageObj of filtered_images) {
            if (!(imageObj.type == 'lifestyle' && imageObj.filename == selectedDeleteLifestyle && imageObj.scene_id == selectedLifestyleSceneId)) {
                allProdImages.push(imageObj);
            }
        }
        var next_image = getNextImageURL(filtered_images)
        let image_index = filtered_images.findIndex(img => img.url == next_image);
        setSelectedImage(filtered_images[image_index - 1])
        setSelectedProductImage(allProdImages[image_index - 1].url);
        setSelectedImageResolution(filtered_images[image_index - 1].resolution);
        setSelectedImageFormat(filtered_images[image_index - 1].format);
        setSelectedImageName(filtered_images[image_index - 1].display_name);
        setSelectedImageCapturedBy(filtered_images[image_index - 1].captured_by);
        setSelectedImageType(filtered_images[image_index - 1].main_type);
        setSelectedImageCreationDate(filtered_images[image_index - 1].created_at);

        changeCarouselSlide(image_index - 1);
        setImgAccessedFromCarousel(true);
    }

    const deleteAiImage = () => {
        setDeleteLoader(true)
        let payload = {
            action: "delete_ai_image",
            id: selectedAiImageId,
        }

        axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload)
        .then(res => {
            setDeleteLoader(false)
            setDeleteModal(false)
            message.info('AI Image Deleted.')
            window.location.reload()
        })
    }

    const deleteAiVideo = () => {
        setDeleteLoader(true)
        let payload = {
            action: "delete_ai_video",
            id: selectedAiImageId,
        }

        axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload)
        .then(res => {
            setDeleteLoader(false)
            setDeleteModal(false)
            message.info('Video Deleted.')
            window.location.reload()
        })
        // const allProdImages = [];
        // for (const imageObj of allProductImages) {
        //     if (!(imageObj.type == 'ai_lifestyle' && imageObj.id == selectedAiImageId)) {
        //         allProdImages.push(imageObj);
        //     }
        // }
        
        // setDeleteLoader(false);
        // setDeleteModal(false);

        // var next_image = getNextImageURLForAI(allProductImages)
        // let image_index = allProductImages.findIndex(img => img.url == next_image);
        // setSelectedImage(allProductImages[image_index])
        // setSelectedProductImage(allProductImages[image_index].url);
        // setSelectedImageResolution(allProductImages[image_index].resolution);
        // setSelectedImageFormat(allProductImages[image_index].format);
        // setSelectedImageName(allProductImages[image_index].display_name);
        // setSelectedImageCapturedBy(allProductImages[image_index].captured_by);
        // setSelectedImageType(allProductImages[image_index].main_type);
        // setSelectedImageCreationDate(allProductImages[image_index ].created_at);

        // changeCarouselSlide(image_index);
        // setImgAccessedFromCarousel(true);
        
        // message.info('AI Image Deleted.');
        // setProductImageCount(productImageCount - 1);
        // setAllProductImages(allProdImages)
    }

    const renderFavIcon = () => {
        let filtered_images = getFilteredImagesForTab();
        let images = filtered_images.filter(img => img.url === selectedProductImage);
        let image = null;
        if(images.length == 1){
            image = images[0]
        }
        if (image && ((image.type == "lifestyle" && getStatus() != 'pending') || (image.type == "silo" && getStatus() != 'pending'))) {
            return image.isFavourite ? (
                <Tooltip title={<span className="manrope f-12 white">Unfavorite</span>}>
                <div
                     className={`pointer-event-auto carousel-ico heart ai`}
                    onClick={(e) => handleFavorite()}
                >
                    <HeartFilled style={{ fontSize: "24px" }} />
                </div>
                </Tooltip>
            ) : (
                <Tooltip title={<span className="manrope f-12 white">Favorite</span>}>
                <div
                     className={`pointer-event-auto carousel-ico heart ai`}
                    onClick={(e) => handleFavorite()}
                >
                    <HeartOutlined style={{ fontSize: "24px" }} />
                </div>
                </Tooltip>
            );
        }
    }

    const updatedRenderNameInImagesList = (url, updatedDisplayName) => {
        let filtered_images = allProductImages;
        let updatedList = filtered_images.map(item => {
          if(item.url === url){
              return { ...item, display_name: updatedDisplayName };
          }
          else{
            return item;
          }
        })
        setAllProductImages(updatedList)
    }

    const renameRenderName = () => {
        let filtered_images = getFilteredImagesForTab();
        setEditRenderNameLoader(true)
        let renderNameField = document.getElementById("render-name");
        renderNameField.contentEditable = false
        let updatedName = renderNameField.innerText

        let selectedObj = filtered_images.filter(item => item.url === editedRenderUrl)[0]
        if(updatedName.trim().length){
            if(selectedImageType == 'silo' && selectedObj){
                let payload = {
                    product_id: `${selectedObj.product_id}`,
                    action: 'rename_silo',
                    camera_name: selectedObj.camera_name,
                    updated_render_name: updatedName
                }
                if(COMPANY_ID){
                    payload['company_id'] = COMPANY_ID
                }
                else{
                    payload['customer_username'] = CUSTOMER_USERNAME
                }
                axios.post(ENVIRONMENT.POST_PRODUCT_ASSET_UPDATE, payload)
                .then(res => {
                    setSelectedImageName(updatedName)
                    updatedRenderNameInImagesList(editedRenderUrl, updatedName)
                    resetRenderNameField()
                })
            }
            else if(selectedImageType == 'lifestyle' && selectedObj){
                let payload = {
                    scene_id: `${selectedObj.scene_id}`,
                    render_name: {
                    [selectedObj.filename]: updatedName
                    }
                }
                axios.post(ENVIRONMENT.UPDATE_SCENE, payload)
                .then(res => {
                    setSelectedImageName(updatedName)
                    updatedRenderNameInImagesList(editedRenderUrl, updatedName)
                    resetRenderNameField()
                })
            }
            else if(selectedImageType == 'ai_lifestyle' && selectedObj){
                let payload = {
                    id: `${selectedObj.id}`,
                    display_name: updatedName,
                    action: 'edit_ai_image_name'
                }
                console.log(payload)
                axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload)
                .then(res => {
                    setSelectedImageName(updatedName)
                    updatedRenderNameInImagesList(editedRenderUrl, updatedName)
                    resetRenderNameField()
                })
            }
        }
        else{
            renderNameField.innerText = previousRenderName
            resetRenderNameField()
        }
    }

    const resetRenderNameField = () => {
        let renderNameField = document.getElementById("render-name");
        if (renderNameField) {
            renderNameField.contentEditable = false;
            setEditRenderNameLoader(false)
            setEditedRenderUrl(null)
            setFilenameBeingEdited(false)
        }
        
    }

    const makeRenderNameEditable = () => {
        let renderNameField = document.getElementById("render-name");
        if (renderNameField) {
            renderNameField.contentEditable = true;
            setFilenameBeingEdited(true)
            setPreviousRenderName(renderNameField.innerText)
        }
    }

    const deleteSilo = () => {
        let filtered_images = getFilteredImagesForTab();
        setDeleteLoader(true)
        let payload = {
            action: "delete",
            product_id: product_id,
            camera_name: selectedDeleteSilo,
            customer_username: CUSTOMER_USERNAME
        }

        if (companyId) {
            payload.company_id = companyId
        }

        axios.post(ENVIRONMENT.POST_PRODUCT_ASSET_UPDATE, payload)
        const allImages = [];
        for (const imageObj of productAssetData['silo_data']) {
            if (imageObj.camera_name !== selectedDeleteSilo) {
                allImages.unshift(imageObj);
            }
        }

        productAssetData['silo_data'] = allImages
        productAssetData['lifestyle_data'] = productAssetData['lifestyle_data'].reverse()

        setDeleteLoader(false);
        setDeleteModal(false);
        message.info('Silo Image Deleted.');
        allSystemGeneratedProductImages(productAssetData);

        const allProdImages = [];
        for (const imageObj of filtered_images) {
            if (!(imageObj.type == 'silo' && imageObj.filename.split('.')[0] == selectedDeleteSilo)) {
                allProdImages.push(imageObj);
            }
        }
        var next_image = getNextImageURL(filtered_images)
        let image_index = filtered_images.findIndex(img => img.url == next_image);
        setSelectedProductImage(allProdImages[image_index - 1].url);
        changeCarouselSlide(image_index - 1);
        setImgAccessedFromCarousel(true);
    }

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleChange = (e) => {
        setIsEditing(false);
        setSelectedImageName(e.target.value);
    };

    const handleBlur = () => {
        setIsEditing(false);
    };

    const open3DView = () => {
        setViewing3D(true);
        
    }

    const openDeleteLifestyleModal = (image_data) => {
        setDeleteModal(true);
        setDeleteImageType(image_data.type)
        setSelectedDeleteLifestyle(image_data.filename)
        setSelectedLifestyleSceneId(image_data.scene_id)
    }

    const openDeleteSiloModal = (image_data) => {
        setDeleteImageType(image_data.type)
        setDeleteModal(true);
        setSelectedDeleteSilo(image_data.camera_name)
        setSelectedDeleteSiloURL(image_data.url)
    }

    const openDeleteAiImageModal = (image_data) => {
        setDeleteImageType("AI")
        setDeleteModal(true);
        setSelectedAiImageId(image_data.id)
    }

    const openDeleteAiVideoModal = (image_data) => {
        setDeleteImageType("Video")
        setDeleteModal(true);
        setSelectedAiImageId(image_data.id)
    }

    const handleDeleteModal = (image) => {
        selectImage(image.url)
        if (image.type == 'lifestyle') {
            openDeleteLifestyleModal(image)
        }
        else if (image.type == 'silo') {
            openDeleteSiloModal(image)
        }
        else if(image.type == 'ai_lifestyle'){
            openDeleteAiImageModal(image)
        }
        else if(image.type == 'ai_video'){
            openDeleteAiVideoModal(image)
        }
    }

    const goToAddLifestyle = () => {
        window.location.href = "/add-lifestyle/" + product_id + "?origin=/products/"+product_id;
    }

    const gotoSiloPresetModal = () => {
        setOpenSiloPresetModal(true)
    }
    
    const goToSilo = () => {
        window.location.href = "/silo-tool/" + product_id + "?origin=/products/"+product_id;
    }


    const menu_bottom = (
        <Menu style={{ width: "148px" }}>
            <Menu.Item disabled={modelStatus == 16 && isAiModel} className='manrope f-14' key={6} onClick={goToAddLifestyle}>
                <span className='cursor-pointer'>Generate Lifestyle</span>
            </Menu.Item>
            <SubMenu disabled={modelStatus == 16 && isAiModel} className='manrope f-14' title={<span  className='manrope f-14'>Generate Silos</span>} popupOffset={[0, 0]}>
                <Menu.Item className='manrope f-14' key={4} onClick={()=>goToSilo()} >
                    <span className='cursor-pointer'>From Scratch</span>
                </Menu.Item>
                <Menu.Item disabled={allPresets.length==0} key={5} onClick={()=>gotoSiloPresetModal()} className='manrope f-14'>
                    <span style={allPresets.length==0 ? {cursor:"not-allowed"} : {cursor:"pointer"}} className='cursor-pointer'>From a Saved Preset</span>
                </Menu.Item>
            </SubMenu>
            <Menu.Item className='manrope f-14' key={0} onClick={openVideoModal} disabled={statusOfMp4Video == "pending" ||  modelStatus == 16 && isAiModel}>
                <Tooltip title={statusOfMp4Video == "pending" ? "We are processing your MP4 Video request at the moment. You’ll be able to request a new MP4 Video once that request is complete. " : ""}>
                    <span className='cursor-pointer'>MP4 Video</span>
                </Tooltip>
            </Menu.Item>
            <Menu.Item disabled={modelStatus == 16 && isAiModel} key={1} onClick={openDimensionalModal} className='manrope f-14'>
                <span className='cursor-pointer'>Dimensional Image</span>
            </Menu.Item>
            <Menu.Item className='manrope f-14' key={2} onClick={openThreeSixtyModal} disabled={statusOf360Spin == "pending" ||  modelStatus == 16 && isAiModel}>
                <Tooltip title={statusOf360Spin == "pending" ? "We are processing your 360 Spin request at the moment. You’ll be able to request a new 360 Spin once that request is complete. " : ""}>
                    <span className='cursor-pointer'>Product 360 Spin</span>
                </Tooltip>
            </Menu.Item>
            <Menu.Item disabled={modelStatus == 16 && isAiModel} key={3} onClick={openVariationModal} className='manrope f-14'>
                <span className='cursor-pointer'>Product Variant</span>
            </Menu.Item>
        </Menu>
    );

    useEffect(() => {
        if (viewing3D == true) {
            let viewer = null
            let viewerFrameId = null
            let otherViewerFrameId = null
            if(viewingAiModel){
                viewer = document.getElementById('all-section-model-viewer-3d-ai');
                viewerFrameId = 'all-section-model-inspector-frame-ai'
                otherViewerFrameId = 'all-section-model-inspector-frame'
            }
            else{
                viewer = document.getElementById('all-section-model-viewer-3d');
                viewerFrameId = 'all-section-model-inspector-frame'
                otherViewerFrameId = 'all-section-model-inspector-frame-ai'
            }
            let message = {
                key: ProductPageConstants.MODEL_VIEWER_KEY,
                glbURL: getDownloadUrl("GLB"),
                metadata: null,
                debugMode: false,
                hdri: productData?.company_hdri
            }

            if (productData?.company_pattern_materials.length > 0) {
                message.patternOptions = productData?.company_pattern_materials;
            }
            if (productData?.company_hdr_options) {
                message.hdrOptions = productData?.company_hdr_options;
            }

            if ((isAiModel && modelStatus != 5) || (viewingAiModel)) {
                message['glbURL'] = getDownloadUrl("AI GENERATED GLB");
            }

            if (viewer && viewer.contentWindow) {
                // display block once the viewer loads
                if ((!viewingAiModel && ifIframe2LoadedOnce == false) || (viewingAiModel && aiIframe2LoadOnce == false)) {
                    viewer.onload = () => {
                        viewer.contentWindow.postMessage(message, "*");
                        if (document.getElementById(viewerFrameId) != undefined) {
                            document.getElementById(viewerFrameId).style.display = 'block';
                            if(viewingAiModel){
                                setAiIframe2LoadOnce(true)
                            }
                            else{
                                setIfIframe2LoadedOnce(true);
                            }
                        }
                    }
                    viewer.src = FileConstants.ModelInspector + product_id; // This forces a reload if necessary
                    if(document.getElementById(otherViewerFrameId))
                        document.getElementById(otherViewerFrameId).style.display = 'none'
                } else if (document.getElementById(viewerFrameId) != undefined) {
                    document.getElementById(viewerFrameId).style.display = 'block';
                    if(document.getElementById(otherViewerFrameId))
                        document.getElementById(otherViewerFrameId).style.display = 'none'
                }
            } 
        } 

    }, [viewing3D, viewingAiModel, document.getElementById('all-section-model-inspector-frame-ai'), document.getElementById('all-section-model-viewer-3d-ai'), document.getElementById('all-section-model-inspector-frame'), document.getElementById('all-section-model-viewer-3d')])

    const handleKeyPressForRename = (keyCode) => {
        if(keyCode == 13){
            // Enter is Pressed
            renameRenderName()
        }
        else if(keyCode == 27){
            // ESC is pressed
            let scene_render_field = document.getElementById('render-name');
            scene_render_field.contentEditable = false;
            scene_render_field.innerText = previousRenderName;
    
            setFilenameBeingEdited(false)
            setEditedRenderUrl(null)
            setEditRenderNameLoader(false)
        }
    }

    const handleMouseEnter = () => {
        if (!filenameBeingEdited) {
            setTooltipVisible(true)
        }
    };
    
    const handleMouseLeave = () => {
        setTooltipVisible(false)
    };

    const generateFinalImage = (selectedImage) => {
        setFinalImageGenerationLoader(true)
        let payload = {
            "action": "trigger_final_image_generation_job",
            "base_image_id": selectedImage.id,
        }
        console.log(payload)
        axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload).then((res) => {
            setFinalImageGenerationLoader(false)
            window.location.reload();
        });
    }

    const handleSubmitForReview = (obj) => {

        console.log('render',obj);
        message.loading('Submitting for review...');
        
        const payload = {
            action: "add_review_image",
            submitted_by: CUSTOMER_USERNAME,
            product_id: obj.product_id
        };
        
        if(obj?.asset_type == 'ai_video' || obj?.image_type == 'ai_video'){
            payload['video_id'] = obj.id;
            payload['action'] = "add_review_video"
        }
        else{
            payload['image_id'] = obj.id
        }
        axios.post(ENVIRONMENT.REVIEW_IMAGE_CONTROLLER, payload)
            .then((res) => {
                message.success("Image submitted for review successfully!");
            })
            .catch((error) => {
                message.error("Error submitting image for review");
                console.error(error);
            });
      }

    const getFilteredImagesForTab = () => {
        if (!tab_name) {
            return allProductImages;
        }

        if (tab_name === "final_images") {
            return allProductImages.filter(img => 
                (img.main_type === 'ai_lifestyle') && 
                img?.is_final_image === true
            );
        }

        if (tab_name === "1k_previews") {
            return allProductImages.filter(img => 
                (img.main_type === 'ai_lifestyle') && 
                !img?.is_final_image
            );
        }

        if (tab_name === "ai_videos") {
            return allProductImages.filter(img => 
                img.main_type === 'ai_video'
            );
        }

        return allProductImages;
    }

    const menu = (
        <Menu style={{ width: "148px" }}>
            <Menu.Item key={0}>
                <a onClick={() => {
                    Utilities.downloadFile(selectedImageFormat == "tiff" ? selectedProductImage.replace("jpg", "tiff") : selectedProductImage, selectedImageName, selectedImageFormat)
                }}
                    className='manrope f-14 black-55' download>This image only</a>
            </Menu.Item>
            {productAssetData && productAssetData['silo_data']?.length > 0 && <Menu.Item key={1}>
                <div className='manrope f-14 black-55' onClick={() => downloadSiloImages()}>Silo Images</div>
            </Menu.Item>}
            <Menu.Item key={2}>
                <div className='manrope f-14 black-55' onClick={() => downloadImagesArchive()}>All Images</div>
            </Menu.Item>
            {COMPANY_ID == ENVIRONMENT.WALMART_COMPANY_ID && selectedImageType == 'lifestyle' ?
            <Menu.Item key={3}>
                <div className='manrope f-14 black-55' onClick={() => Utilities.generateAndDownloadWatermarkedImage(selectedImageFormat == "tiff" ? selectedProductImage.replace("jpg", "tiff") : selectedProductImage, selectedImageName + '.' + selectedImageFormat )}>Watermarked Image</div>
            </Menu.Item> : ''}
        </Menu>
    );

    const formatDate = (dateString) => {
        const utcDateString = dateString.endsWith('Z') ? dateString : dateString + 'Z';
        const date = new Date(utcDateString);
        const formattedDate = date.toLocaleDateString("en-US", {
        weekday: "long",
        month: "short",
        day: "2-digit",
        year: "numeric"
        }).replace(",", "");
        return formattedDate;        
    }

    // Set 3D model as selected by default when switching to 'all' tab and GLB is present
    useEffect(() => {
        if (openAllTab) {
            // Only auto-select when switching TO 'all' tab (not when already on 'all' and other things change)
            const switchedToAll = selectedAsset == 'all' && prevSelectedAssetRef.current != 'all';

            if (switchedToAll && hasGlb() && !viewing3D) {
                open3DView();
                // For AI models, set viewingAiModel based on modelStatus
                if (isAiModel) {
                    setViewingAiModel(true);
                }
            }

            // Update the ref to track previous selectedAsset
            prevSelectedAssetRef.current = selectedAsset;
        }
    }, [selectedAsset, isAiModel, modelStatus, openAllTab]);
    
    return (
        <>
        <Row>
            <Col md={7} lg={7} xl={4} className='display-flex j-s a-s wrap sa-s gg-16 custom-scroll product-grid-list'>
            {selectedAsset == 'all' && modelStatus == 5 && !isAiModel &&
                <img className={`${isAiModel ? 'product-img-grid-card display-flex' : 'model3d-thumbnail'}  ${viewing3D && !viewingAiModel ? 'selected': ''}`} style={{objectFit: 'contain'}} 
                src={productData?.thumbnail.replace(ENVIRONMENT.DEFAULT_BASE_URL, ENVIRONMENT.getBaseURL(productData.platform))}
                onClick={() => {
                    open3DView();
                    setViewingAiModel(false)}
                }/>}
                {selectedAsset == 'all' && isAiModel &&  hasGlb() &&
                    <div style={{position: 'relative', cursor: 'pointer'}} onClick={() => {
                        open3DView();
                        setViewingAiModel(true)}
                    }>
                        <img className={`${isAiModel ? 'product-img-grid-card display-flex' : 'model3d-thumbnail'} ${viewing3D && (viewingAiModel || modelStatus == 16) ? 'selected': ''}`} style={{objectFit: 'contain'}} src={productData?.thumbnail.replace(ENVIRONMENT.DEFAULT_BASE_URL, ENVIRONMENT.getBaseURL(productData.platform))}/>
                        <div style={{position: 'absolute', top: 5, left: 5, background: '#FAFAFA', padding: 3, borderRadius: 4}}>
                            <img src='/img/sparkleIconSmall.svg' />
                        </div>
                    </div>
                }
                {!tab_name && 
                <div className='w-100'>
                    <h4 className='manrope f-16 w-500 black-00 mb-0'>{isAiModel ? "Your Images" : "Your Assets"}</h4>
                </div>}
                {!tab_name && (
                    <>
                        <ImageListType
                            isAiModel={isAiModel}
                            viewing3D={viewing3D}
                            handleDeleteModal={handleDeleteModal}
                            allProductImages={allProductImages}
                            type={["silo"]}
                            name={"Silo Images"}
                            selectImage={selectImage}
                            selectedProductImage={selectedProductImage}
                            setSelectedDeleteSilo={setSelectedDeleteSilo}
                            setDeleteImageType={setDeleteImageType}
                            setDeleteModal={setDeleteModal}
                            setSelectedDeleteSiloURL={setSelectedDeleteSiloURL}
                            setSelectedFilenameWithExtension={setSelectedFilenameWithExtension}
                        />
                        <ImageListType
                            isAiModel={isAiModel}
                            viewing3D={viewing3D}
                            allProductImages={allProductImages}
                            type={["dim"]}
                            name={"DIM"}
                            selectImage={selectImage}
                            selectedProductImage={selectedProductImage}
                        />
                        <ImageListType
                            isAiModel={isAiModel}
                            viewing3D={viewing3D}
                            allProductImages={allProductImages}
                            type={["low_res_preview"]}
                            name={isAiModel ? "Silo Reference" : "Previews"}
                            selectImage={selectImage}
                            selectedProductImage={selectedProductImage}
                        />
                        <ImageListType
                            isAiModel={isAiModel}
                            viewing3D={viewing3D}
                            handleDeleteModal={handleDeleteModal}
                            allProductImages={allProductImages}
                            type={["lifestyle"]}
                            name={"Lifestyle Images"}
                            selectImage={selectImage}
                            selectedProductImage={selectedProductImage}
                            setDeleteModal={setDeleteModal}
                            setDeleteImageType={setDeleteImageType}
                            setSelectedDeleteLifestyle={setSelectedDeleteLifestyle}
                            setSelectedLifestyleSceneId={setSelectedLifestyleSceneId}
                            setSelectedFilenameWithExtension={setSelectedFilenameWithExtension}
                        />
                    </>
                )}

                {(!tab_name || tab_name === "final_images") && (
                    <ImageListType
                        isAiModel={isAiModel}
                        viewing3D={viewing3D}
                        allProductImages={allProductImages}
                        type={["ai_lifestyle"]}
                        name={"Final Images"}
                        selectImage={selectImage}
                        selectedProductImage={selectedProductImage}
                        setSelectedAiImageId={setSelectedAiImageId}
                        setDeleteModal={setDeleteModal}
                        handleDeleteModal={handleDeleteModal}
                    />
                )}
                {(!tab_name || tab_name === "1k_previews") && (
                    <ImageListType
                        isAiModel={isAiModel}
                        viewing3D={viewing3D}
                        allProductImages={allProductImages}
                        type={["ai_lifestyle"]}
                        name={"Previews"}
                        selectImage={selectImage}
                        selectedProductImage={selectedProductImage}
                        setSelectedAiImageId={setSelectedAiImageId}
                        setDeleteModal={setDeleteModal}
                        handleDeleteModal={handleDeleteModal}
                    />
                )}
                {(!tab_name || tab_name === "ai_videos") && (
                    <ImageListType
                        isAiModel={isAiModel}
                        viewing3D={viewing3D}
                        allProductImages={allProductImages}
                        type={["ai_video"]}
                        name={"Videos"}
                        selectImage={selectImage}
                        selectedProductImage={selectedProductImage}
                        setSelectedAiImageId={setSelectedAiImageId}
                        setDeleteModal={setDeleteModal}
                        handleDeleteModal={handleDeleteModal}
                    />
                )}
            </Col>
            {isAiModel ?
            <Col md={17} lg={17} xl={20} className='w-100' style={{borderLeft: '1px solid #D9D9D9'}}>
                {viewing3D && selectedAsset == 'all' ? "" : <AIImageCarousel
                    from="product_page"
                    prev={prev}
                    next={next}
                    image_source={selectedProductImage}
                    product_id={product_id}
                    filteredImages={getFilteredImagesForTab()}
                    displayedImages={getFilteredImagesForTab()}
                    carouselIndex={getFilteredImagesForTab().findIndex(img => img.url == selectedProductImage)}
                    ref={carousel}
                    getFullResolution={selectedImageResolution}
                    imageFormat={Utilities.getImageFormat(selectedProductImage)}
                    selectedImg={selectedImage}
                    imageDate={selectedImageCreationDate}
                    createdBy={selectedImageCapturedBy}
                    generateFinalImage={generateFinalImage}
                    generateFinalImageLoader={finalImageGenerationLoader}
                    handleDeleteModal={handleDeleteModal}
                    handleMouseEnter={handleMouseEnter}
                    handleMouseLeave={handleMouseLeave}
                    handleKeyPressForRename={handleKeyPressForRename}
                    makeRenderNameEditable={makeRenderNameEditable}
                    renameRenderName={renameRenderName}
                    editRenderNameLoader={editRenderNameLoader}
                    editedRenderUrl={editedRenderUrl}
                    tooltipVisible={tooltipVisible}
                    selectedImageType={selectedImageType}
                    setEditedRenderUrl={setEditedRenderUrl}
                    filenameBeingEdited={filenameBeingEdited}
                    handleFavorite={handleFavorite}
                    handleUnfavorite={handleFavorite}
                    handleSubmitForReview={handleSubmitForReview}
                />}
                        <div className={viewing3D && selectedAsset == 'all' ? 'glb-height-ai' : ""} style={{ display: viewing3D && selectedAsset == 'all' ? "block" : 'none' }}>
                            <Row id='all-section-model-inspector-frame-ai' className='model-inspector-viewer-customer-ai'>
                                <iframe id='all-section-model-viewer-3d-ai' className='model-inspector-frame-customer' />
                            </Row>
                        </div>
                        
            </Col>
            : <Col md={17} lg={17} xl={20} className='w-100'>
                    <div className={ viewing3D && selectedAsset == 'all' ? 'glb-height-ai' : ""} style={{display: viewing3D && selectedAsset == 'all' ? "block" : 'none'}}>
                        <Row id='all-section-model-inspector-frame' className='model-inspector-viewer-customer-ai'>
                            <iframe id='all-section-model-viewer-3d' className='model-inspector-frame-customer' />
                        </Row>
                        
                    </div>
                    {viewing3D && selectedAsset == 'all' ?  "" :
                    <>
                        <Col span={24} className='resolutionText align-center ml-32' style={{ marginBottom: 20 }}>
                            <div>
                                <div className="display-flex justify-start align-center mb-8" style={{ width: "80%" }}>

                                    {isAiModel && modelStatus != 5 && 
                                    <div className='justify-in-start'>
                                        <img src="/img/ai_creator/ai-twinkle-gradient.png" className='ml-2' />
                                        <div className='ai-badge manrope f-20 w-700 mr-4'>AI</div>
                                    </div>}

                                    {selectedImageName &&
                                        <div className='justify-in-start'>
                                            <Tooltip visible={tooltipVisible} title={<span className="manrope f-12 white">{selectedImageName}</span>}>

                                                <h4 id='render-name' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onKeyDown={(e) => { e.stopPropagation(); handleKeyPressForRename(e.keyCode) }}
                                                    className={`manrope f-20 clamp-text w-100 mb-0 scene-render-name${editedRenderUrl == selectedProductImage ? `-editable` : ``}`}>
                                                    {selectedImageName}</h4>
                                            </Tooltip>

                                            {selectedImageType == 'ai_lifestyle' || selectedImageType == 'silo' || selectedImageType == 'lifestyle' || selectedImageType == 'ai_video' ?
                                                filenameBeingEdited && editedRenderUrl == selectedProductImage ?
                                                    <Button disabled={editRenderNameLoader} style={{ display: 'flex', justifyContent: 'flex-end' }} className="save-button font-12 ml-10" onClick={() => {
                                                        renameRenderName()
                                                    }}>
                                                        Save {editRenderNameLoader ? <LoadingOutlined /> : ''}
                                                    </Button>
                                                    :
                                                    <div onClick={() => { makeRenderNameEditable(); setEditedRenderUrl(selectedProductImage) }} className="edit-icon-data-small edit-icon-blue mt-0" >
                                                        <EditOutlined className='edit-icon-property ml-10' />
                                                    </div>
                                                : ''}
                                        </div>}
                                </div>
                                <div className='manrope f-12 grey-66 w-500'>
                                    {selectedImageResolution && selectedImageFormat ?
                                        <span className="manrope w-500 f-12 mb-0 mr-10" style={{color: 'black'}}>
                                            {selectedImageResolution ? selectedImageResolution : ''}  {selectedImageFormat ? selectedImageFormat.toUpperCase() : ''}
                                        </span>
                                    : ''}
                                    {
                                        selectedImageCreationDate && selectedImageCreationDate != "Invalid Date" &&
                                            <span>
                                                Created on {formatDate(selectedImageCreationDate)}  
                                            </span>    
                                    }
                                    {
                                        selectedImageCapturedBy && selectedImageCreationDate && selectedImageCreationDate != "Invalid Date" ?
                                            <span>
                                                &nbsp;by <span className='manrope w-600'>{selectedImageCapturedBy}</span>
                                            </span>
                                        :
                                            selectedImageCapturedBy ? 
                                            <span> 
                                                Created by <span className='manrope w-600'>{selectedImageCapturedBy}</span>
                                            </span> : ''
                                    }
                                </div>
                            </div>
                            
                            <div className='qr-code-section small'>
                                <div style={{ display: 'flex' }}>
                                    <img src="/img/ai_creator/room_cube.svg" />
                                    <div className='qr-code-text mr-16'>View in room</div>
                                </div>
                                <QRCode style={{ height: 56, width: 56 }} className="qr-code" value={`d1rzyeqsmooian.cloudfront.net/ar-viewer/${product_id}?platform=${productData.platform}&env=${ENVIRONMENT.ENV}${isAiModel && modelStatus != 5 ? '&ai=true' : ''}` } />
                            </div>
                        </Col>

                    {!isStorePage && (selectedImageType == 'ai_lifestyle') &&
                        <div
                            className={`silo-image-collaborate-icon edit-width white border mt-30 carousel-ico edit ai`}
                            onClick={() => {
                                const imageUrl = encodeURIComponent(selectedProductImage);
                                const productId = product_id;
                                const promptText = encodeURIComponent(selectedImage?.flux_prompt || selectedImage?.prompt_text);
                                window.location.href = `/edit-ai-image?imageUrl=${imageUrl}&imageId=${selectedImage.id}&productId=${productId}&promptText=${promptText}`;
                            }}>
                            <img
                                className='collaborate-img'
                                src='/img/Edit.svg'
                                alt="Edit Icon"
                            />
                            <span
                                className={'manrope f-14 w-500'}
                            >
                                Edit
                            </span>
                        </div>}
                        
                    {getStatus() !== 'pending' && !isStorePage && (selectedImageType == 'silo' || selectedImageType == 'lifestyle') &&
                        <div
                            className={`silo-image-collaborate-icon white border mt-30 carousel-ico collab ai`}
                            onClick={() => setCollaborationConfirmModal(true)}>
                            <img
                                className='collaborate-img'
                                src='/img/collaborate_tool/new-new-collab.svg'
                                alt="Collaboration Icon"
                            />
                            <span
                                className={'manrope f-14 w-500'}
                            >
                                Collaborate
                            </span>
                        </div>}

                    
                    <FullscreenOutlined className={`carousel-ico fs ai`} 
                    onClick={() => expandImage(selectedImage?.url)} 
                    />
                     
                {getStatus() != "pending" && renderFavIcon()}
                {(getStatus() == "pending" || getStatus() == "requested") &&
                    <div className="render-in-progress">
                        Render in Progress
                    </div>}
                <div className="carousel-btns right-btn top-50" onClick={next}>
                    <ArrowRightOutlined className="arrow" />
                </div>
                <Carousel autoplay={false} ref={carousel} className='w-100 product-carousel padding-10'
                    beforeChange={onChangeCarousel}>
                    {allProductImages.map((img, index) => (
                        <div key={index}>
                            {<ZoomImage
                                image={img.url}
                                index={index}
                                asset_viewer_modal={true}
                                className="product-carousel-image"
                            />}
                        <Image
                            preview={{
                            visible: image_visible[img.url],
                            onVisibleChange: changeVisibility,
                            }}
                            className="new-lifestyle-image-settings hide-display"
                            src={img.url}
                        />
                        </div>
                    ))}
                </Carousel>
                <div className="carousel-btns left-btn top-50 left-42" onClick={prev}>
                    <ArrowLeftOutlined className="arrow" />
                </div>
                <div className={`count-tag product ai`}>
                    <div className='manrope f-14 white lh-28'>{getImageNumber()} of {productImageCount}</div>
                </div>
                
                <Row className='justify-space-between mt-24 ml-32'>
                    <Col span={12} className='justify-in-start'>
                       {/* {isAiModel &&
                       <Button className='modal-okay-gray square font-14 mr-8'>
                            <PictureOutlined /> Regenerate This Image
                        </Button>} */}
                        
                        {/* <Tooltip title={<span className='manrope f-12 white'>Flag this image</span>}>
                            <span>
                                <Button
                                    className="red-icon-button-container mr-8">
                                    <FlagOutlined />
                                </Button>
                            </span>
                        </Tooltip> */}
                        {(selectedImage?.type == "lifestyle" || (selectedImage?.type == 'silo' && selectedImage?.status != 'pending' || selectedImage?.type == "ai_lifestyle")) &&
                        <Tooltip title={<span className='manrope f-12 white'>Delete this image</span>}>
                            <span>
                                <Button onClick={() => handleDeleteModal(selectedImage)}
                                    className="red-icon-button-container">
                                    <DeleteOutlined />
                                </Button>
                            </span>
                        </Tooltip>}
                    </Col>
                    <Col span={12} className='justify-in-end'>
                        {getStatus() != "pending" && !isStorePage &&
                        <Dropdown overlay={menu} trigger={['click']} className='mr-8'>
                            <Button className='modal-okay-gray square font-14'>
                                Download <DownOutlined />
                            </Button>
                        </Dropdown>}

                        {!ENVIRONMENT.COMPANY_IDS_WITH_CUSTOM_AI_OUTPUTS.includes(localStorage.getItem("company_id")) &&
                        <Button className='generate-ai-btn font-14 mr-8' onClick={() => {
                            if (modelStatus==5) {
                                window.location.href = ENVIRONMENT.PORTAL_LINK + 'ai-asset-creator?stage=lifestyle_generation&productId=' + product_id
                            }
                            if (modelStatus!=5) {
                                window.location.href = ENVIRONMENT.PORTAL_LINK + 'ai-asset-creator?stage=lifestyle_generation&productId='+product_id+'&aiModel=true'
                            }
                                
                            }}>
                            <img src="/img/ai_creator/ai-twinkle.svg" /> Generate AI Images
                        </Button>}
                        {/* <Tooltip title={modelStatus == 16 && isAiModel ? <span className='manrope f-12 white'>Please refine the model before requesting assets</span> : ""}>
                            <Dropdown overlay={menu_bottom} 
                            trigger={['click']}>
                                <Button className='modal-okay-gray square font-14'>
                                    More <DownOutlined />
                                </Button>
                            </Dropdown>
                        </Tooltip> */}
                        {!selectedImage?.is_final_image && <Button  onClick={() => generateFinalImage(selectedImage)} className='product-btn dark-blue f-14 br-4' ghost disabled={finalImageGenerationLoader}>
                            {finalImageGenerationLoader && <LoadingOutlined /> }
                            Download Final Image
                        </Button>}
                    </Col>
                </Row>
                </>}
            </Col>}
            </Row>

            <DeleteImageModal
                deleteModal={deleteModal}
                setDeleteModal={setDeleteModal}
                deleteImageType={deleteImageType}
                deleteLifestyle={deleteLifestyle}
                deleteSilo={deleteSilo}
                deleteLoader={deleteLoader}
                deleteAiImage={deleteAiImage}
                deleteAiVideo={deleteAiVideo}
            />
        <SiloPhotographyPresetsModal id={product_id} openSiloPresetModal={openSiloPresetModal} selectedPreset={selectedPreset} allPresets={allPresets} setSelectedPreset={setSelectedPreset} setOpenSiloPresetModal={setOpenSiloPresetModal} />
        <Modal
        destroyOnClose={true}
        className="modal-space"
        width={700}
        visible={collaborationConfirmModal}
        closable={false}
        bodyStyle={{padding: 0}}
        footer={[
            <span className="justify-in-end">
                <Button disabled={collaborateConfirmButtonLoader} style={{textAlign:"center"}} className="modal-okay-gray square font-12" onClick={() => setCollaborationConfirmModal(false)}>
                    Cancel
                </Button>
                <Button disabled={collaborateConfirmButtonLoader} style={{textAlign:"center"}} className="modal-okay square font-12" onClick={openCollaborateTool}>
                    {collaborateConfirmButtonLoader ? <span>Please wait.. <LoadingOutlined spin /></span>:<span>Go to tool </span>}
                </Button>
            </span>
        ]}
        >
        <div style={{padding: 30, display: 'flex'}}>
            <Col span={24}>
            <h2 className="modal-heading manrope f-14 black-00 w-600">Go to collaborate tool? </h2>
            <p className="manrope f-12 black-33">This tool will allow you to post any feedback you have for this render. </p>
            </Col>
        </div>
        </Modal>
        </>
    );
}
export default ProductImageCarousel;